/**
 * Component for navigating to case details/update page
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Props for the UpdateCase component
 */
interface UpdateCaseProps {
  /**
   * ID of the case to update
   */
  caseId: string;
  
  /**
   * Callback function called when a case is successfully updated (optional)
   */
  onSuccess?: () => void;
}

/**
 * Component that navigates users to the case details page
 */
export function UpdateCase({ caseId }: UpdateCaseProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/cases/${caseId}`);
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1 text-blue-600 hover:text-blue-800 px-2 py-1 rounded-md hover:bg-blue-50"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      <span>Update</span>
    </button>
  );
}
